module.exports = __webpack_public_path__ + "static/img/加载中.e390ece8.gif";